import { render, staticRenderFns } from "./ClcResolutionsDasboard.vue?vue&type=template&id=0b9527a2&"
import script from "./ClcResolutionsDasboard.vue?vue&type=script&lang=js&"
export * from "./ClcResolutionsDasboard.vue?vue&type=script&lang=js&"
import style0 from "./ClcResolutionsDasboard.vue?vue&type=style&index=0&id=0b9527a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports